import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import OrderForm from "../stores/OrderForm";
import LicensingInfo from "./OrderFormWidget/LicensingInfoWidget";
import SchedulingInstructions from "./OrderFormWidget/SchedulingInstructionsWidget";
import ThankYouMessage from "./OrderFormWidget/ThankYouMessageWidget";
import OrderFormVariation from "./OrderFormWidget/OrderFormVariationWidget";

@observer
class OrderFormWidget extends Component {
  render() {
    const { providerId, providerDomain, store, redirect } = this.props;

    if (store.loading) {
      return (
        <div>
          <h2>Tour Plans & A-La-Carte Options</h2>
          <span className="help">loading...</span>
        </div>
      );
    }

    return (
      <div>
        <h2>Custom Headings</h2>
        <div id="custom-headings">
          <div className="label-input">
            <label htmlFor="customHeading1">Custom Heading 1</label>
            <input
              type="text"
              name="customHeading1"
              value={store.customHeading1}
              onChange={event => store.updateCustomHeading1(event.target.value)}
            />
            <br />
            <span className="help">Default: {store.defaultHeading1}</span>
          </div>
          <div className="label-input">
            <label htmlFor="customHeading2">Custom Heading 2</label>
            <input
              type="text"
              name="customHeading2"
              value={store.customHeading2}
              onChange={event => store.updateCustomHeading2(event.target.value)}
            />
            <br />
            <span className="help">Default: {store.defaultHeading2}</span>
          </div>
        </div>
        <h2>Tour Plans & A-La-Carte Options</h2>
        {store.variations.map(orderFormVariation => (
          <OrderFormVariation
            key={orderFormVariation.id}
            {...orderFormVariation}
            hasMultipleVariations={store.variations.length > 1}
            providerId={providerId}
            providerDomain={providerDomain}
            errors={
              typeof store.variationsErrors[orderFormVariation.id] !== "undefined"
                ? store.variationsErrors[orderFormVariation.id]
                : {}
            }
            onVariationNameChangeCallback={value => store.updateOrderFormVariationName(orderFormVariation.id, value)}
            onServiceLabelChangeCallback={(serviceId, value) => store.updateServiceLabel(serviceId, value)}
            onLineItemInputChangeCallback={(lineItemId, property, value) =>
              store.updateLineItem(lineItemId, property, value)
            }
            onAddLineItemCallback={section => store.addLineItem(orderFormVariation.id, section)}
            onAddServiceCallback={() => store.addService(orderFormVariation.id)}
            onRemoveLineItemCallback={lineItemId => store.removeLineItem(lineItemId)}
            onRemoveOrderFormVariationCallback={() => store.removeOrderFormVariation(orderFormVariation.id)}
            onAddLineItemToServiceCallback={serviceId => store.addLineItemToService(serviceId)}
            onRemoveServiceCallback={serviceId => store.removeService(serviceId)}
          />
        ))}
        {/* We'll only show the button if the provider already has multiple forms, until turn the order form
         wizard in an actual multi-screen wizard (including editing custom fields).
         */}
        {store.variations.length > 1 ? (
          <a
            href="#"
            onClick={event => {
              event.preventDefault();
              store.addOrderFormVariation();
            }}
          >
            <i className="add icon" style={{ textDecoration: "none" }} />
            Add Custom Set
          </a>
        ) : (
          <div className="help">
            You can add multiple variations of your plans and a-la-carte options &nbsp;
            <a
              href="#"
              onClick={event => {
                event.preventDefault();
                store.addOrderFormVariation();
              }}
            >
              clicking here
            </a>
          </div>
        )}

        <LicensingInfo
          licensingInfo={store.licensingInfo}
          onChangeCallback={value => store.updateLicensingInfo(value)}
        />
        <SchedulingInstructions
          enableBuiltInScheduling={store.enableBuiltInScheduling}
          scheduleRequired={store.scheduleRequired}
          schedulingInstructions={store.schedulingInstructions}
          onEnableBuiltInSchedulingChangeCallback={() => store.toggleEnableBuiltInScheduling()}
          onSchedulingInstructionsChangeCallback={value => store.updateSchedulingInstructions(value)}
          onScheduleRequiredChangeCallback={() => store.toggleScheduleRequired()}
        />
        <ThankYouMessage
          thankYouMessage={store.thankYouMessage}
          onChangeCallback={value => store.updateThankYouMessage(value)}
        />
        <br />
        <br />

        <div>
          <button
            type="button"
            className="button"
            disabled={store.posting}
            onClick={() =>
              store.handleSubmit(() => {
                window.location = redirect;
              })
            }
          >
            {store.posting ? "Saving..." : "Next"}
          </button>
        </div>
      </div>
    );
  }
}

OrderFormWidget.propTypes = {
  store: PropTypes.instanceOf(OrderForm).isRequired,
  providerId: PropTypes.number.isRequired,
  providerDomain: PropTypes.string.isRequired,
  redirect: PropTypes.string.isRequired,
};

export default OrderFormWidget;
